export default {
	save: 'Изменения успешно сохранены',
	error: 'Ошибка. Обратитесь в службу поддержки',
	'old password was incorrect': 'Старый пароль был неправильным',
	templateDuplicated: 'Шаблон успешно продублирован',

}